export default (buildId, region, project = 'StackeryFactory') => {
  return `https://${region}.console.aws.amazon.com/codesuite/codebuild/projects/${project}/build/${buildId}/log?region=${region}`;
};
